export default "__VITE_ASSET__Be3aBlEB__"